// center the slider arrows on the product image rather than the whole
// card (image + title + price + swatches), since that varies in height
function alignSliderArrows(root) {
  root.querySelectorAll(".products-feed__slider-wrapper").forEach((wrapper) => {
    const media = wrapper.querySelector(".product-card__media");
    const buttons = wrapper.querySelector(".products-feed__slider-buttons");
    if (!media || !buttons) return;

    const wrapperRect = wrapper.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();
    if (!mediaRect.height) return;

    const top = (mediaRect.top - wrapperRect.top) + mediaRect.height / 2;
    buttons.style.top = `${top}px`;
  });
}

function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  const activeTab = document.getElementById(tabName);
  activeTab.style.display = "block";
  evt.currentTarget.className += " active";

  // the swiper inside this tab was measured while hidden (display: none),
  // so its slide sizes need to be recalculated now that it's visible
  const swiperEl = activeTab.querySelector("swiper-component");
  if (swiperEl) {
    requestAnimationFrame(() => {
      if (swiperEl.swiper) {
        swiperEl.swiper.update();
      } else if (typeof swiperEl.init === "function") {
        swiperEl.init();
      }
      alignSliderArrows(activeTab);
    });
  }
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});
window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});

window.addEventListener("load", () => alignSliderArrows(document));
window.addEventListener("resize", () => alignSliderArrows(document));
